module.exports = __webpack_public_path__ + "img/PFASHIO.bcb0763f.jpg";